import ClientService from '../../../../services/client-service';
import logoutUserMutation from '../../../../graphql/mutation/logout-user.graphql';
import closeUserSessionsMutation from '../../../../graphql/mutation/close-user-sessions.graphql';

export default class LogoutApi {
  public static logoutUser(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(logoutUserMutation, payload);
  }

  public static closeUserSessions(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(closeUserSessionsMutation, payload);
  }
}
